import { actionCreatorFactory } from 'typescript-fsa/lib';
import { FeaturedCluster } from '../Entities/FeaturedCluster/featured-cluster.reducer';
const actionCreator = actionCreatorFactory('Story');

export const startEditing = actionCreator('FEATURED_CLUSTER_EDIT_START_EDIT');

export const startLoading = actionCreator(
  'FEATURED_CLUSTER_EDIT_START_LOADING'
);
export const stopLoading = actionCreator('FEATURED_CLUSTER_EDIT_STOP_LOADING');

export const featuredClusterEditChangeGender = actionCreator<string>(
  'FEATURED_CLUSTER_EDIT_CHANGE_GENDER'
);
export const featuredClusterEditChangeCountryId = actionCreator<number>(
  'FEATURED_CLUSTER_EDIT_CHANGE_COUNTRYID'
);

export const featuredClusterEditReorder = actionCreator<FeaturedCluster[]>(
  'FEATURED_CLUSTER_EDIT_REORDER'
);

export const featuredClusterEditSave = actionCreator(
  'FEATURED_CLUSTER_EDIT_SAVED'
);

export const featuredClusterEditAddCluster = actionCreator<FeaturedCluster>(
  'FEATURED_CLUSTER_EDIT_ADD_CLUSTER'
);

export const featuredClusterEditRemoveCluster = actionCreator<FeaturedCluster>(
  'FEATURED_CLUSTER_EDIT_REMOVE_CLUSTER'
);



// WEBPACK FOOTER //
// ./src/store/FeaturedClusterEdit/featured-cluster-edit.actions.ts